import { TABLE_TYPES } from '../../tableTypes';
import { SECTION_3_TABLE_NAMES_V1 as SECTION_3_TABLE_NAMES } from '../tableNames';

export const SECTION_3_TABLES = {
  [SECTION_3_TABLE_NAMES.LIQUIDITY_FUND_INFO]: {
    questionLevels: [
      {
        columns: {
          name: { name: 'Name of the reporting fund', level: '(a)' },
          fund_id_field: {
            name: 'Private fund identification number of the reporting fund',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.USE_AMORTIZED_COST_METHOD]: {
    questionLevels: [
      {
        columns: {
          use_amortized_cost_method: {
            name: 'Does the reporting fund use the amortized cost method of valuation in computing its net asset value?'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.USE_PENNY_ROUNDING_METHOD]: {
    questionLevels: [
      {
        columns: {
          use_penny_rounding_method: {
            name: 'Does the reporting fund use the penny rounding method of pricing in computing its net asset value?'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.COMPLY_RULE_2A7_POLICY]: {
    questionLevels: [
      {
        columns: {
          comply_rule_2a7_risk_condition: {
            name: 'Does the reporting fund have a policy of complying with the risk limiting conditions of rule 2a-7?',
            level: '(a)'
          }
        }
      },
      {
        level: '(b)',
        name: 'If you responded “no” to Question 54(a) above, does the reporting fund have a policy of complying with the following provisions of rule 2a-7:',
        columns: {
          comply_rule_2a7_diversification_condition: {
            name: 'the diversification conditions?',
            level: 'i'
          },
          comply_rule_2a7_credit_quality_condition: {
            name: 'the credit quality conditions?',
            level: 'ii'
          },
          comply_rule_2a7_liquidity_condition: {
            name: 'the liquidity conditions?',
            level: 'iii'
          },
          comply_rule_2a7_maturity_condition: {
            name: 'the maturity conditions?',
            level: 'iv'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.LIQUIDITY_FUND_ASSETS]: {
    type: TABLE_TYPES.RANKING_TABLE,
    questionLevels: [
      {
        name: 'Provide the following information for each month of the reporting period.',
        columns: {
          ranking: { name: 'Ranking' },
          net_asset_value: {
            name: 'Net asset value of reporting fund as reported to current and prospective investors',
            level: '(a)'
          },
          nav_per_share: {
            name: 'Net asset value per share of reporting fund as reported to current and prospective investors (to the nearest hundredth of a cent) ',
            level: '(b)'
          },
          nav_per_share_except_capital_support: {
            name: ' Net asset value per share of reporting fund (to the nearest hundredth of a cent; exclude the value of any capital support agreement or similar arrangement) ',
            level: '(c)'
          },
          wam: { name: 'WAM of reporting fund (in days)', level: '(d)' },
          wal: { name: 'WAL of reporting fund (in days)', level: '(e)' },
          seven_days_gross_yield: {
            name: '7-day gross yield of reporting fund (to the nearest hundredth of one percent)',
            level: '(f)'
          },
          amount_daily_liquid_assets: {
            name: "Dollar amount of the reporting fund's assets that are daily liquid assets",
            level: '(g)'
          },
          amount_weekly_liquid_assets: {
            name: "Dollar amount of the reporting fund's assets that are weekly liquid assets",
            level: '(h)'
          },
          amount_greater_than_397_days: {
            name: "Dollar amount of the reporting fund's assets that have a maturity greater than 397 days",
            level: '(i)'
          },
          cash_amount: { name: 'Amount of cash held by the reporting fund', level: '(j)' },
          amount_gross_subscriptions: {
            name: 'Total gross subscriptions (including dividend reinvestments) ',
            level: '(k)'
          },
          amount_gross_redemptions: { name: 'Total gross redemptions ', level: '(l)' }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.LIQUIDITY_FUND_FINANCING]: {
    questionLevels: [
      {
        columns: {
          is_borrowing_more_than_5_percent: {
            name: "Is the amount of total borrowing reported in response to Question 12 equal to or greater than 5% of the reporting fund's net asset value?",
            level: '(a)'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.BORROWING_DETAIL]: {
    type: TABLE_TYPES.TURNOVER,
    groupColumn: 'depository_institutions',
    rankLevels: ['i', 'i', 'i', 'ii', 'ii', 'ii'],
    questionLevels: [
      {
        name: 'If you responded “yes” to Question 54(a) above, divide the dollar amount of total borrowing reported in response to Question 12 among the periods specified below depending on the type of borrowing, the type of creditor and the latest date on which the reporting fund may repay the principal amount of the borrowing without defaulting or incurring penalties or additional fees.  (If a creditor (or syndicate or administrative/collateral agent) is permitted to vary unilaterally the economic terms of the financing or to revalue posted collateral in its own discretion and demand additional collateral, then the borrowing should be deemed to have a maturity of 1 day or less for purposes of this question.  For amortizing loans, each amortization payment should be treated separately and grouped with other borrowings based on its payment date.)(The total amount of borrowings reported below should equal approximately the total amount of borrowing reported in response to Question 12.) ',
        columns: {
          one_day_or_less: {
            name: '1 day or less'
          },
          two_to_seven_days: {
            name: '2 days to 7 days'
          },
          eight_to_thirty_days: {
            name: '8 days to 30 days'
          },
          thirty_one_to_397_days: {
            name: '31 days to 397 days'
          },
          greater_than_397_days: {
            name: 'Greater than 397 days'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.STABLE_PRICE]: {
    questionLevels: [
      {
        columns: {
          is_stable_price_maintained: {
            name: 'Does the reporting fund seek to maintain a stable price per share?',
            level: '(a)'
          },
          price_per_share: {
            name: 'If you responded “yes” to Question 57(a), provide the aggregate dollar amount of commitments under the liquidity facilities',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.INVESTOR_OUTSTANDING_SHARES_OF_STOCK]: {
    questionLevels: [
      {
        columns: {
          outstanding_shares_of_stock: {
            name: "Specify the number of outstanding shares or units of the reporting fund's stock or similar securities"
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.BENEFICIALLY_OWNED_5_PERCENT_EQUITY_BY_INVESTORS]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Provide the following information regarding investor concentration.',
        columns: {
          fund_investor_code: {
            name: "Specify the percentage of the reporting fund's equity that is beneficially owned by the beneficial owner having the largest equity interest in the reporting fund."
          },
          beneficially_owned_percentage: {
            name: "How many investors beneficially own 5% or more of the reporting fund's equity?"
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.SECURITIES_LENDING_COLLATERAL]: {
    questionLevels: [
      {
        columns: {
          percentage_equity_purchased_using_collateral: {
            name: "Provide a good faith estimate, as of the data reporting date, of the percentage of the reporting fund's outstanding equity that was purchased using securities lending collateral"
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.WITHDRAWAL_REDEMPTION_RESTRICTIONS]: {
    questionLevels: [
      {
        name: ' Provide the following information regarding the restrictions on withdrawals and redemptions by investors in the reporting fund.',
        columns: {
          maybe_subjected_to_suspension: {
            name: "May be subjected to a suspension of investor withdrawals/redemptions by an adviser or fund governing body (this question relates to an adviser's or governing body's right to suspend and not just whether a suspension is currently effective).",
            level: '(a)'
          },
          maybe_subjected_to_material_restrictions: {
            name: "May be subjected to material restrictions on investor withdrawals/ redemptions (e.g., “gates”) by an adviser or fund governing body (this question relates to an adviser's or governing body's right to impose a restriction and not just whether a restriction been imposed).,",
            level: '(b)'
          },
          subjected_to_suspension: {
            name: "Is subject to a suspension of investor withdrawals/redemptions (this question relates to whether a suspension is currently effective and not just an adviser's or governing body's right to suspend).",
            level: '(c)'
          },
          subjected_to_material_restrictions: {
            name: "Is subject to a material restriction on investor withdrawals/redemptions (e.g., a “gate”) (this question relates to whether a restriction has been imposed and not just an adviser's or governing body's right to impose a restriction).",
            level: '(d)'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.INVESTOR_LIQUIDITY]: {
    questionLevels: [
      {
        name: 'Investor liquidity (as a % of net asset value): (Divide the reporting fund’s net asset value among the periods specified below depending on the shortest period within which investors are entitled, under the fund documents, to withdraw invested funds or receive redemption payments, as applicable.  Assume that you would impose gates where applicable but that you would not completely suspend withdrawals/redemptions and that there are no redemption fees.  Please base on the notice period before the valuation date rather than the date proceeds would be paid to investors. The total should add up to 100%.)',
        columns: {
          one_day_or_less: { name: '1 day or less' },
          days_2_to_7: { name: '2 days – 7 days' },
          days_8_to_30: { name: '8 days – 30 days' },
          days_31_to_90: { name: '31 days – 90 days' },
          days_91_to_180: { name: '91 days – 180 days' },
          days_181_to_365: { name: '181 days – 365 days' },
          longer_than_365_days: { name: 'Longer than 365 days' }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.PORTFOLIO]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'For each security held by the reporting fund, provide the following information for each month of the reporting period.',
        columns: {
          reporting_period_month: { name: 'Reporting Period Month' },
          issuer_name: { name: 'Name of the issuer', level: '(a)' },
          issue_title: {
            name: 'Title of the issue (including coupon, if applicable)',
            level: '(b)'
          },
          cusip: { name: 'CUSIP', level: '(c)' },
          legal_entity_id: { name: 'LEI, if available', level: '(d)' }
        }
      },
      {
        name: 'For each security held by the reporting fund, provide the following information for each month of the reporting period.',
        level: '(e)',
        columns: {
          isin: { name: 'ISIN', level: 'i' },
          cik: { name: 'CIK', level: 'ii' },
          other_identifier: {
            name: 'Other unique identifier (indicate identifier and type of identifier)',
            level: 'iii'
          }
        }
      },
      {
        name: 'For each security held by the reporting fund, provide the following information for each month of the reporting period.',
        columns: {
          investment_category: {
            name: 'The category of investment that most closely identifies the instrument  421 (Select from among the following categories of investment: U.S. Treasury Debt; U.S. Government Agency Debt (if categorized as coupon-paying notes); U.S. Government Agency Debt (if categorized as no-coupon-discount notes); Non-U.S. Sovereign, Sub-Sovereign and Supra-National debt; Certificate of Deposit;  Non-Negotiable Time Deposit; Variable Rate Demand Note; Other Municipal Security; Asset Backed Commercial Paper; Other Asset Backed Securities; U.S. Treasury Repo Agreement, if collateralized only by U.S. Treasuries (including Strips) and cash; U.S. Government Agency Repo Agreement, collateralized only by U.S. Government Agency securities, U.S. Treasuries, and cash; Other Repo Agreement, if any collateral falls outside Treasury, Government Agency and cash; Insurance Company Funding Agreement; Investment Company; Financial Company Commercial Paper; Non-Financial Company Commercial Paper; Tender Option Bond; or Other Instrument. If Other Instrument, include a brief description.) ',
            level: '(f)'
          },
          other_instrument_description: {
            name: 'If Other Instrument, include a brief description, including, if applicable, whether it is a collateralized debt obligation, municipal debt, whole loan, or international debt.',
            level: '(g)'
          }
        }
      }
    ]
  },
  [SECTION_3_TABLE_NAMES.MONEY_MARKET_FUND]: {
    questionLevels: [
      {
        columns: {
          edgar_id_of_money_market_fund: {
            name: 'If the reporting fund pursues substantially the same investment objective and strategy and invests side by side in substantially the same positions as a money market fund advised by you or any of 425 your related persons, provide the money market fund’s EDGAR series identifier.  (If neither you nor any of your related persons advise such a money market fund, enter “NA.”) '
          }
        }
      }
    ]
  }
};
